<script setup lang="ts">
defineProps<{
  title: string
  positionType: string
  level: string
  icon: string
  location: string
  job: {slug: string}
  slug: string
}>()

const localePath = useLocalePath()
</script>

<template>
  <NuxtLink
    :to="localePath(`/careers/${job.slug}`)"
    :class="[
      'flex flex-col gap-4 rounded-lg bg-gray-50 p-8 transition-all bordershadow-gray',
      'hover:bg-white hover:bordershadow-lg-gray',
    ]"
  >
    <div :class="['h-16 w-16', 'hidden sm:block']">
      <img :src="icon" alt="icon" class="mb-10 h-full w-full" />
    </div>

    <div class="pt-5">
      <h2 class="mb-2 text-xl font-bold">
        {{ title }}
      </h2>

      <div class="flex flex-col text-[18px] text-[#6E7191]">
        <span class="mt-3 flex flex-row items-center text-base capitalize">
          <img src="/jobs/position.svg" class="mr-3 w-[18px]" alt="" />{{ positionType }}
        </span>
        <span class="mt-3 flex flex-row items-center text-base capitalize">
          <img src="/jobs/location.svg" class="mr-3 w-[18px]" alt="" />{{ location }}
        </span>
        <span class="mt-3 flex flex-row items-center text-base capitalize">
          <img src="/jobs/job.svg" class="mr-3 w-[18px]" alt="" />{{ level }}
        </span>
      </div>
      <div class="mt-4 flex items-center font-medium text-main-600">
        {{ $t('common.see_more') }}
        <Icon class="ml-2" name="lucide:move-right" />
      </div>
    </div>
  </NuxtLink>
</template>

<style scoped>
.gradient-border:hover {
  position: relative;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 16px;
    padding: 2px;
    background: linear-gradient(116.01deg, #42e88e 21.84%, #2fd3c7 48.91%, #00b3cc 84.46%);
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }
}
</style>
